import React, { useState, useEffect } from "react";
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import swal from 'sweetalert';
import {
  Button, Box, Card, CardContent, FormControlLabel, Checkbox,
  Grid, Typography, TextField, InputLabel, MenuItem, FormControl, Select, FormGroup
} from '@mui/material';
import Avatar from '@mui/material/Avatar';
const EditEvent = ({ match }) => {
  const { id } = match.params;
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [userList, setUserList] = useState([]);
  const [allModules, setAllModules] = useState([]);
  const [formData, setFormData] = useState({
    eventname: "",
    user_id: "",
    user_modules: []
  });

  // Fetch event data and all necessary options
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [eventRes, usersRes, modulesRes] = await Promise.all([
          axios.get(`api/superadmin-editevent/${id}`),
          axios.get('api/superadmin-alluser'),
          axios.get('api/superadmin-allmodules')
        ]);

        if (eventRes.status === 200) {
          setFormData(eventRes.data.event);
        }
        if (usersRes.status === 200) setUserList(usersRes.data.users);
        if (modulesRes.status === 200) setAllModules(modulesRes.data.modules);
      } catch (error) {
        console.error("Failed to fetch data:", error);
        swal("Error", "Failed to load event data", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e, moduleId) => {
    const checked = e.target.checked;
    
    setFormData(prevState => {
      const updatedUserModules = checked
        ? [...prevState.user_modules, { module_id: moduleId }]
        : prevState.user_modules.filter(module => module.module_id !== moduleId);
      
      return {
        ...prevState,
        user_modules: updatedUserModules
      };
    });
  };
console.log("id", id);  
const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
        await axios.get('/sanctum/csrf-cookie');
        
        // Prepare the payload - ensure correct structure
        const payload = {
            eventname: formData.eventname,
            user_id: formData.user_id,
            user_modules: formData.user_modules.map(mod => ({
                module_id: typeof mod === 'object' ? mod.module_id : mod
            }))
        };

        console.log("Sending payload:", payload); // Debug log

        const res = await axios.put(`api/superadmin-updateEvent/${id}`, payload);

        if (res.data.status === 200) {
            history.push('/master/events');
            swal("Success", res.data.message, "success");
        } else {
            swal("Error", res.data.message || "Update failed", "error");
        }
    } catch (error) {
        console.error("Update error:", {
            message: error.message,
            response: error.response?.data,
            request: error.request
        });
        swal("Error", error.response?.data?.message || "Failed to update event", "error");
    } finally {
        setLoading(false);
    }
};
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       await axios.get('/sanctum/csrf-cookie');
//       const res = await axios.put(`api/superadmin-updateEvent/${id}`, {
//         eventname: formData.eventname,
//         user_id: formData.user_id,
//         user_modules: formData.user_modules
//       });

//       if (res.data.status === 200) {
//         history.push('/master/events');
//         swal("Success", res.data.message, "success");
//       } else {
//         swal("Error", res.data.message || "Update failed", "error");
//       }
//     } catch (error) {
//       console.error("Update error:", error);
//       swal("Error", "Failed to update event", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
      <Box sx={{ color: '#000000', marginTop: '5%' }}>
        <h4 style={{ marginBottom: '20px' }}>
          <Button
            sx={{
              float: 'right',
              marginTop: '2%',
              ":hover": { color: "white" }
            }}
            color='success'
            size='small'
            variant='contained'
            component={Link}
            to="/master/events"
          >
            Back
          </Button>
        </h4>
        <Card sx={{ width: '60vw' }}>
          <CardContent>
            <Typography component="h1" variant="h5">
              Edit Event {id}
            </Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    required
                    fullWidth
                    label="Event Name"
                    name="eventname"
                    value={formData.eventname || ""}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel>Select User</InputLabel>
                    <Select
                      name="user_id"
                      value={formData.user_id || ""}
                      onChange={handleInputChange}
                      label="Select User"
                    >
                      {userList.map(item => (
                         <MenuItem value={item.id} key={item.id}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Avatar sx={{ width: 32, height: 32 }}>
                              {item.name.charAt(0).toUpperCase()}
                            </Avatar>
                            <Box>
                              <Typography variant="subtitle2">{item.name}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                {item.email}
                              </Typography>
                            </Box>
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    Select Modules:
                  </Typography>
                  <FormGroup row>
                    {allModules.map(item => {
                      const isChecked = formData.user_modules.some(
                        mod => mod.module_id === item.id
                      );
                      return (
                        <FormControlLabel
                          key={item.id}
                          control={
                            <Checkbox
                              checked={isChecked}
                              onChange={(e) => handleCheckboxChange(e, item.id)}
                            />
                          }
                          label={item.module}
                        />
                      );
                    })}
                  </FormGroup>
                </Grid>
              </Grid>
              <Grid container justifyContent="flex-end">
                <Button
                  type="submit"
                  variant="contained"
                  disabled={loading}
                  sx={{ mt: 3, mb: 2 }}
                >
                  {loading ? 'Updating...' : 'Update Event'}
                </Button>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </div>
  );
};

export default EditEvent;